/**
 * Rotas do portal do colaborador CLT.
 *
 * O ponto trouxe `/colaborador/espelho` e `/colaborador/ajustes`. A marcação saiu
 * do portal: é só no quiosque da loja (ADR 0032).
 */
export const COLABORADOR_LOGIN = () => "/colaborador/entrar";
export const COLABORADOR_HOME = () => "/colaborador";
export const COLABORADOR_PRIMEIRO_ACESSO = () => "/colaborador/primeiro-acesso";
export const COLABORADOR_SENHA = () => "/colaborador/senha";
export const COLABORADOR_FERIAS = () => "/colaborador/ferias";
export const COLABORADOR_AFASTAMENTOS = () => "/colaborador/afastamentos";
export const COLABORADOR_ESCALA = () => "/colaborador/escala";
export const COLABORADOR_ESPELHO = () => "/colaborador/espelho";
export const COLABORADOR_AJUSTES = () => "/colaborador/ajustes";
export const COLABORADOR_CONTRACHEQUES = () => "/colaborador/contracheques";
/** Comprovantes de marcação dos últimos 60 dias (Portaria 671, art. 80). */
export const COLABORADOR_COMPROVANTES = () => "/colaborador/comprovantes";
